/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { CaretDownFilled, CaretRightFilled, EllipsisOutlined, PlusOutlined } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Collapse,
  Divider,
  Input,
  notification,
  Row,
  Space,
  Image, Popover, Select, Modal,
  Dropdown,
  Menu
} from 'antd'
import { RcFile, UploadFile } from 'antd/lib/upload/interface'
import _ from 'lodash'
import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import {
  selectIsGray,
  selectShortName,
  selectTenantAddress,
  selectTenantCityCode,
  selectTenantId,
  selectTenantName,
  selectTimestamp
} from '../../../app/applicationSlice'
import { RootDispatch } from '../../../app/store'
import FileUpload from '../../../compnents/file/FileUpload'
import { Label } from '../../../compnents/widgets/Label'
import { patientInfo } from '../../../models/intelligence'
import { PrintTemplateCategory } from '../../../models/print'
import {
  BeautyValue,
  MedicalValue,
  TemplateDetail,
} from '../../../models/template'
import { TreatmentNotice } from '../../../models/treatment'
import { ThemeContext } from '../../../theme/ThemeContext'
import { useQuery } from '../../../utils/HttpUtils'
import { imagesType } from '../../../utils/StringUtils'
import { PrintFrame, PrintFrameRef } from '../../print/PrintFrame'
import { PrintTemplateModal } from '../../print/PrintTemplateModal'
import { UploadModal } from '../../putstorelist/Query/uploadModal'
import { SaveTemplateModal } from '../../template/SaveTemplateModal'
import { deleteUploadFileList } from '../diagnosis/diagnosisSlice'
import { PreferencesSetModal } from '../diagnosis/preferencesSetModal'
import styles from "../../medicalBeautyTemplate/MedicalBeautyTemplateEditor.module.css";
import {
  getBeaytyClinicDetail,
  getBeaytyClinicList,
  getCloseTreatmentBeautySignQRCodeAsync,
  getMedicalDetailAsync,
  getMedicalListAsync,
  getMedicalRemoveAsync,
  getTreatment,
  getTreatments,
  getUrl,
  getVideoSave, historicalRecordsCopy,
  selectRegistration,
  selectTreatmentB, setTreatment,
} from './beautyClinicSlice'
import DCWriterControl, {
  EditorRendering,
  ImportComponent,
  setWriterControl_OnLoad, StringToUtf8Base64,
} from "../../medicalBeautyTemplate/DCWriterControl";
import Handle_EventShowContextMenu from "../../medicalBeautyTemplate/ContextMenuSetting";
import { saveTreatmentBeauty } from "../../medicalBeautyTemplate/MedicalBeautyTemplateSlice";
import { DelectOutlined } from "../../../compnents/icons/Icons";
import { ReactComponent as FemaleFilledIcon } from '../../../compnents/icons/svg/filled/view.svg'
import { HistoricalRecords } from "./historicalRecords";
import { getPatientDetailInfoAsync } from "../../patient/modals/patientSlice";
import { Patient } from "../../../models/patient";
import { UploadSignatureModal } from './uploadSignatureModal'
import { getPrintTemplateSettingUserList } from '../../print/printSlice'
import { getSignatureAsync } from '../../personalManagement/personalDetail/personalDetailSlice'

export interface BeautyClinicRef {
  submit: () => Promise<void>
  showTreatments: () => void
}

interface DiagnosisProps {
  tabKey?: string
  readMode?: boolean
  state?: number
  saveEdit?: () => void
  PreferencesSetChange?: () => void
}

const templateNames = [
  {
    id: 1,
    name: '个人模版',
    type: 3
  },
  {
    id: 2,
    name: '机构模版',
    type: 2
  },
  {
    id: 3,
    name: '系统模版',
    type: 1
  },
]

const RealBeautyClinicDC = (
  { readMode = false, saveEdit, PreferencesSetChange }: DiagnosisProps,
  ref: React.Ref<BeautyClinicRef>
): ReactElement => {
  const printRef = useRef<PrintFrameRef>(null)
  const tenantId = useSelector(selectTenantId)
  const dispatch = useDispatch<RootDispatch>()

  const location: any = useLocation()

  const [xml, setXml] = useState<any>('')

  const [data, setData] = useState<MedicalValue[]>([])

  const theme = useContext(ThemeContext)

  const query = useQuery()

  const registration = useSelector(selectRegistration)

  const treatment = useSelector(selectTreatmentB)

  const cityCode = useSelector(selectTenantCityCode)

  const [selectedDiseases, setSelectedDiseases] = useState<any>()

  const [templateKeyword, setTemplateKeyword] = useState('')

  const [templates, setTemplates] = useState<BeautyValue[]>([])

  const EditorRef = useRef<any>(null)

  const [isPrintModalVisible, setIsPrintModalVisible] = useState(false)

  const [templateDetails, setTemplateDetails] = useState<
    Record<string, BeautyValue[]>
  >({})

  const registrationId = query.get('registrationId') as string

  const treatmentId = query.get('treatmentId') as string

  const [patientId, setPatientId] = useState(-1)


  const [targetTemplate, setTargetTemplate] = useState<
    TemplateDetail | undefined
  >(undefined)

  const tenantName = useSelector(selectShortName)
  const isGray = useSelector(selectIsGray)

  const tenantAddress = useSelector(selectTenantAddress)

  const timestamp = useSelector(selectTimestamp)

  const [historicalRecordsBtn, setHistoricalRecordsBtn] = useState(false)  //上传按钮 loading

  const [visible, setVisible] = useState(false)   //预览图片是否显示

  const [imgSrc, setImgSrc] = useState('')   //预览图片路径

  const [printStr, setPrintStr] = useState('')

  const refWriterControl = useRef<any>(null);

  const id = query.get('id') as string  //患者管理-病历信息跳转过来的

  const [preferencesSetShow, setiPreferencesSetShow] = useState(false) //偏好设置

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [isUploadSignatureModalVisible, setIsUploadSignatureModalVisible] = useState(false)

  const [patientData, setPatientData] = useState<patientInfo>()

  const [patient, setPatient] = useState<Patient | undefined>()

  const [selectTemplate, setSelectTemplate] = useState('')

  const [selectTemplateName, setSelectTemplateName] = useState<string>('')

  const [selectHistoryId, setSelectHistoryId] = useState<string>('')

  const [loadFinish, setLoadFinish] = useState(false)

  const [hasDZQMUsers, setHasDZQMUsers] = useState<any>([])

  ImportComponent()

  //保存病历
  const saveMedicalRecords = (medicalBeautyId: string, medicalBeautyName: string) => {

    const xmlStr = StringToUtf8Base64(refWriterControl.current.XMLTextForSave)

    const rootElement = refWriterControl.current


    const disease = rootElement.GetInputFieldInnerValue('disease');
    const personalHistory = rootElement.GetInputFieldInnerValue('personalHistory');
    const historyOfPresentIllness = rootElement.GetInputFieldInnerValue('historyOfPresentIllness');
    const chiefComplaint = rootElement.GetInputFieldInnerValue('chiefComplaint');
    const pastMedicalHistory = rootElement.GetInputFieldInnerValue('pastMedicalHistory');
    const treatmentId = treatment?.id && Number(treatment.id) > 0 ? treatment?.id : String(patientData?.registration.treatmentId)

    dispatch(
      saveTreatmentBeauty({
        ...patientData?.registration,
        id: 1,
        registrationId: registrationId,
        treatmentId: treatmentId,
        medicalBeautyId: medicalBeautyId && medicalBeautyId !== '' ? medicalBeautyId : selectTemplate,
        medicalBeautyName: medicalBeautyName && medicalBeautyName !== '' ? medicalBeautyName : selectTemplateName,
        medicalRecord: 4,
        category: 1,
        version: '2',
        itemId: selectHistoryId,
        content: xmlStr,
        disease: disease && disease !== '' ? disease : null,
        personalHistory: personalHistory && personalHistory !== '' ? personalHistory : null,
        historyOfPresentIllness: historyOfPresentIllness && historyOfPresentIllness !== '' ? historyOfPresentIllness : null,
        chiefComplaint: chiefComplaint && chiefComplaint !== '' ? chiefComplaint : null,
        pastMedicalHistory: pastMedicalHistory && pastMedicalHistory !== '' ? pastMedicalHistory : null
      })
    )
      .then(unwrapResult)
      .then((res) => {
        notification.success({
          message: '保存成功',
        })
        getMedical()
        setSelectHistoryId(res.medicalBeautyItem.id)
        dispatch(setTreatment(res.treatment))
      })
  }

  const onParentStateUpdate = (event: string) => {
    switch (event) {
      case 'Save':
        if (selectTemplate === '') {
          Modal.info({
            title: `请选择模版`,
            okText: '确定',
            maskClosable: true,
            keyboard: true,
          })
          return
        }
        saveMedicalRecords('', '')
        break
      default:
        break
    }
  }

  //数据回写
  const writeBack = () => {

    const rootElement = refWriterControl.current

    if (treatment?.disease && treatment?.disease !== '') {
      batchAssignment('disease', treatment?.disease, rootElement);
    }

    if (treatment?.personalHistory && treatment?.personalHistory !== '') {
      batchAssignment('personalHistory', treatment?.personalHistory, rootElement);
    }

    if (treatment?.historyOfPresentIllness && treatment?.historyOfPresentIllness !== '') {
      batchAssignment('historyOfPresentIllness', treatment?.historyOfPresentIllness, rootElement);
    }

    if (treatment?.chiefComplaint && treatment?.chiefComplaint !== '') {
      batchAssignment('chiefComplaint', treatment?.chiefComplaint, rootElement);
    }

    if (treatment?.pastMedicalHistory && treatment?.pastMedicalHistory !== '') {
      batchAssignment('pastMedicalHistory', treatment?.pastMedicalHistory, rootElement);
    }

    //患者信息
    if (patientData?.registration.patientName && patientData?.registration.patientName !== '') {
      batchAssignment('patientName', patientData?.registration.patientName, rootElement);
    }

    if (patientData?.registration.patientAge != null && patientData?.registration.patientAge >= 0) {
      console.log('patientData?.registration.patientAge:', patientData?.registration.patientAge);
      batchAssignment('txtAge', patientData?.registration.patientAge, rootElement);
      batchAssignment('patientAge', patientData?.registration.patientAge, rootElement);
    }

    if (patient?.idCardNumber && patient?.idCardNumber !== '') {
      batchAssignment('patientIdCard', patient?.idCardNumber, rootElement);
    }

    if (patient?.emergencyContactName && patient?.emergencyContactName !== '') {
      batchAssignment('emergencyContactName', patient?.emergencyContactName, rootElement);
    }

    if (patient?.emergencyContactPhone && patient?.emergencyContactPhone !== '') {
      batchAssignment('emergencyContactPhone', patient?.emergencyContactPhone, rootElement);
    }

    if (patient?.birthday && patient?.birthday !== '') {
      batchAssignment('birthday', patient?.birthday, rootElement);
    }

    if (patient?.companyName && patient?.companyName !== '') {
      batchAssignment('patientCompanyName', patient?.companyName, rootElement);
    }

    if (patient?.address && patient?.address !== '') {
      batchAssignment('patientAddress', patient?.address, rootElement);
    }

    if (patient?.height && patient?.height !== '') {
      batchAssignment('patientHeight', patient?.height, rootElement);
    }

    if (patient?.weight && patient?.weight !== '') {
      batchAssignment('patientWeight', patient?.weight, rootElement);
    }

    if (patient?.wechat && patient?.wechat !== '') {
      batchAssignment('patientWechat', patient?.wechat, rootElement);
    }

    if (patient?.emailAddress && patient?.emailAddress !== '') {
      batchAssignment('patientEmailAddress', patient?.emailAddress, rootElement);
    }

    if (patient?.maritalStatus == 1) {
      batchAssignment('patientMaritalStatus', '未婚', rootElement);
      rootElement.SetElementTextByID('patientMaritalStatus', '未婚')
    } else if (patient?.maritalStatus == 2) {
      batchAssignment('patientMaritalStatus', '已婚', rootElement);
    } else {
      batchAssignment('patientMaritalStatus', '未知', rootElement);
    }

    //性别
    if (patientData?.registration.patientSex && patientData?.registration.patientSex > 0) {

      if (patientData?.registration.patientSex === 2) {
        rootElement.SetElementChecked('patientGenderChk1', false)
        rootElement.SetElementChecked('patientGenderChk2', true)
      } else {
        rootElement.SetElementChecked('patientGenderChk1', true)
        rootElement.SetElementChecked('patientGenderChk2', false)
      }
    }

    if (patient?.phone && patient?.phone !== '') {
      batchAssignment('patientPhone', patient?.phone, rootElement);
    }

    if (patientData?.registration.patientAge && patientData?.registration.patientAge > 0) {
      batchAssignment('txtAge', String(patientData?.registration.patientAge), rootElement);
    }

    //机构信息
    if (tenantName && tenantName !== '') {
      batchAssignment('tenantName', tenantName, rootElement);
    }

    if (tenantAddress && tenantAddress !== '') {
      batchAssignment('tenantAddress', tenantAddress, rootElement);
    }

    if (timestamp && timestamp !== '') {
      batchAssignment('tenantPhone', String(timestamp), rootElement);
    }

    //就诊信息
    if (patientData?.registration.registrationDepartmentName && patientData?.registration.registrationDepartmentName !== '') {
      batchAssignment('registrationDepartmentName', patientData?.registration.registrationDepartmentName, rootElement);
    }

    if (patientData?.registration.registrationDoctorName && patientData?.registration.registrationDoctorName !== '') {
      batchAssignment('registrationDoctorName', patientData?.registration.registrationDoctorName, rootElement);
    }

    if (patientData?.registration.registrationTime && patientData?.registration.registrationTime !== '') {
      batchAssignment('registrationTime', patientData?.registration.registrationTime, rootElement);
    }

    if (patientData?.registration.patientId && patientData?.registration.patientId > 0) {
      batchAssignment('outpatientNo', patientData?.registration.patientId, rootElement);
    }

  }


  //同id词条元素 批量赋值
  const batchAssignment = (elementId: string, value: any, ctl: any) => {

    const elements = ctl.GetElementsById(elementId)


    if (elements && elements.length > 0) {

      console.log('DCvalue:', value)
      elements.forEach(function (element: any) {


        const elementProps = ctl.GetElementProperties(element);
        console.log('DC:', elementProps)
        switch (elementProps.TypeName) {
          case 'XTextInputFieldElement': {
            ctl.SetElementTextByID(elementProps.NativeHandle, String(value))
            break
          }
          case 'XTextRadioBoxElement': {
            ctl.SetElementChecked(elementProps.NativeHandle, value)
            break
          }
          default: break
        }
      });
    }
  }

  const getMedical = () => {
    dispatch(
      getMedicalListAsync({
        category: 1,
        showImgFlag: 1,
        registrationId: Number(registrationId),
        version: '2'
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setData(res)
      })
  }
  useEffect(() => {

    dispatch(getTreatment({ registrationId, treatmentId }))
    // if (!readMode) {
    //   dispatch(startTreatment(registrationId))
    // }
  }, [dispatch, registrationId, treatmentId])

  useEffect(() => {

    getMedical()
    dispatch(getBeaytyClinicList({ category: 1, version: '2', templateType: 99 }))
      .then(unwrapResult)
      .then((res: any) => {
        setTemplates(res)
      })
    dispatch(
      getTreatments({
        registrationId,
        treatmentId,
      })
    )
      .then(unwrapResult)
      .then((v: any) => {
        dispatch(getPatientDetailInfoAsync({ id: v.registration.patientId }))
          .then((res: any) => {
            setPatient(res.payload)
          })
        setPatientData(v)
      })

    id && dispatch(
      getMedicalDetailAsync({
        id: Number(id)
      })
    )
      .then(unwrapResult)
      .then((res: string) => {
        EditorRef.current?.importXmltoSde(res)
      })
  }, [dispatch, registration, id])

  useEffect(() => {

    setWriterControl_OnLoad((rootElement: any) => {
      rootElement.style.display = null;

      //右键菜单
      rootElement.EventShowContextMenu = Handle_EventShowContextMenu

      rootElement.Readonly = true

      setLoadFinish(true)
    })
  }, []);

    useEffect(() => {
        dispatch(
            getPrintTemplateSettingUserList({
                state: 1,
                haveSign: 1,
            })
        )
            .then(unwrapResult)
            .then((users: any) => {
                setHasDZQMUsers(users)
            })
    },[])
    

  //编辑器工具栏点击事件
  const handleToolClick = (type: string, data: any) => {
    if (type === 'SelectSignature') {
      dispatch(getSignatureAsync(data))
        .then(unwrapResult)
        .then((res: any) => {
          const rootElement = refWriterControl.current
          const ops = {
            Width: 250,
            Height: 90,
            SaveContentInFile: true,
            Src: res,
            AutoFitImageSize: true
          };
          rootElement.DCExecuteCommand("InsertImage", false, ops);
          setIsUploadSignatureModalVisible(false)
        })
      return;
    }
  }

  return (
    <div
      style={{
        display: 'flex',
        height: 'calc(100% - 5px)',
        position: 'relative',
        flexDirection: 'column',
        marginTop: '5px',
      }}
    >
      <Row
        className={styles.container}
        style={{
          height: '100%',
          overflow: 'hidden',
          flex: 1,
          marginBottom: '10px',
        }}
        wrap={false}
      >
        {!readMode && (
          <Col
            style={{
              width: 230,
              height: '100%',
              marginRight: 10,
              backgroundColor: theme.pn,
              borderRadius: theme.br,
              overflow: 'auto',
            }}
          >
            <Label label='诊断模板' style={{ marginLeft: 20 }} />
            <Divider style={{ margin: '0px' }} />
            <Input
              value={templateKeyword}
              placeholder='请输入内容检索'
              onChange={(e) =>
                setTemplateKeyword((e.target.value || '').trim())
              }
              style={{
                width: 'calc(100% - 40px)',
                marginTop: 20,
                marginLeft: 20,
              }}
              allowClear
            />
            <Collapse
              className={styles.templates}
              bordered={false}
              expandIcon={(v) =>
                v.isActive ? (
                  <CaretDownFilled style={{ lineHeight: '26px' }} />
                ) : (
                  <CaretRightFilled style={{ lineHeight: '26px' }} />
                )
              }
              style={{
                marginTop: 30,
                marginLeft: 20,
                marginRight: 20,
                flex: 1,
                overflow: 'auto',
                backgroundColor: 'transparent',
              }}
            >
              {templateNames.map(t => (
                <Collapse.Panel
                  key={t.type}
                  header={
                    <Row
                      align='middle'
                      justify='space-between'
                      wrap={false}
                      style={{
                        color: undefined,
                        fontWeight: 'normal',
                        width: '100%',
                      }}
                    >
                      <span
                        style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          marginRight: 10,
                        }}
                      >
                        {t.name}
                      </span>
                    </Row>
                  }
                >
                  <Collapse
                    className={styles.secondLevel}
                    bordered={false}
                    expandIcon={(v) =>
                      v.isActive ? (
                        <CaretDownFilled style={{ lineHeight: '26px' }} />
                      ) : (
                        <CaretRightFilled style={{ lineHeight: '26px' }} />
                      )
                    }
                    onChange={(ids) => {
                      _.forEach(ids, (id) => {
                        if (!templateDetails[id]) {
                          const template = templates.find((t) => t.id === Number(id))
                          if (template) {
                            dispatch(
                              getBeaytyClinicList({
                                category: 1,
                                parentId: Number(id),
                                version: '2',
                                templateType: t.type
                              })
                            )
                              .then(unwrapResult)
                              .then((details: any) => {
                                setTemplateDetails({
                                  ...templateDetails,
                                  [id]: details,
                                })
                              })
                          }
                        }
                      })
                    }}
                  >
                    {templates.filter(tt => tt.templateType === t.type).map((t) => (
                      <Collapse.Panel
                        key={t.id}
                        header={
                          <div
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {t.name}
                          </div>
                        }
                      >
                        {templateDetails[t.id] &&
                          templateDetails[t.id]
                            .filter(
                              (d) =>
                                !templateKeyword ||
                                d.name.indexOf(templateKeyword) >= 0 ||
                                (d.mnemonicCode &&
                                  d.mnemonicCode.indexOf(
                                    templateKeyword.toUpperCase()
                                  ) >= 0)
                            )
                            .map((d, i) => (
                              <div
                                key={d.id}
                                onClick={() => {
                                  if (selectedDiseases?.medicalBeautyId !== d.id && loadFinish) {
                                    dispatch(
                                      getBeaytyClinicDetail({
                                        id: d.id,
                                        registrationId: Number(registrationId),
                                        version: '2'
                                      })
                                    )
                                      .then(unwrapResult)
                                      .then((res: string) => {
                                        setSelectTemplate(String(d.id))
                                        setSelectTemplateName(d.name)
                                        setSelectHistoryId('')
                                        EditorRendering(refWriterControl.current, res, false);
                                        writeBack()
                                      })
                                  }
                                }}
                                style={{
                                  color: theme.tc2,
                                  fontSize: '1.125rem',
                                  marginTop: 10,
                                  cursor: 'pointer',
                                }}
                              >
                                {i + 1}. {d.name}
                              </div>
                            ))}
                      </Collapse.Panel>
                    ))}
                  </Collapse>
                </Collapse.Panel>
              ))}
            </Collapse>
          </Col>
        )}
        <Col
          flex='1'
          style={{
            height: '100%',
            borderRadius: theme.br,
            backgroundColor: theme.pn,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            marginRight: 10,
          }}
        >
          <Divider style={{ margin: 0, borderTopColor: theme.th }} />
          <DCWriterControl onParentStateUpdate={onParentStateUpdate}
            editorStyle={{ width: "100%", marginTop: "1px", height: "calc(-250px + 92vh)" }}
            ref={refWriterControl} page={'medicalWrite'} />
          <Row
            justify='end'
            style={{ marginTop: '10px', marginRight: '10px' }}
          >
            <Space>
              {selectTemplate === '' ? <Button
                type='primary'
                onClick={() => {
                  Modal.info({
                    title: `请选择模版`,
                    okText: '确定',
                    maskClosable: true,
                    keyboard: true,
                  })
                }}
              >
                电子签名
              </Button> :
                <Dropdown
                  overlay={
                    <Menu>
                      {hasDZQMUsers.map((item: any) => (
                        <Menu.Item
                          key={item.id}
                          onClick={() => {
                            handleToolClick('SelectSignature', item.id)
                          }}
                        >
                          {item.realname}
                        </Menu.Item>
                      ))}
                    </Menu>
                  }
                  trigger={['click']}
                >
                  {/*<button style={{width:80,height:25,marginTop:8,backgroundColor:'#ffffff',border:'1px solid #d9d9d9' }}>选择签名</button>*/}
                  <Popover content={'选择签名'} key={36}>
                    <Button
                      type='primary'
                      onClick={() => {
                        if (hasDZQMUsers.length === 0) {
                          notification.info({
                            message: '当前没有设置了电子签名的人员，请设置电子签名或购买电子签名个数'
                          })
                        }
                      }}
                    >
                      电子签名
                    </Button>

                  </Popover>

                </Dropdown>
              }
               {isGray != 1 ?
                <Button
                  type='primary'
                  onClick={() => {
                    if (selectTemplate === '') {
                      Modal.info({
                        title: `请选择模版`,
                        okText: '确定',
                        maskClosable: true,
                        keyboard: true,
                      })
                      return
                    } setIsUploadSignatureModalVisible(true)
                  }}
                >
                  扫码签名
                </Button>
                  : <></>}
              <Button
                type='primary'
                onClick={() => {
                  setIsModalVisible(true);
                }}
              >
                查看/选择 历史病历
              </Button>
              <Button
                type='primary'
                onClick={() => {
                  if (selectTemplate === '') {
                    Modal.info({
                      title: `请选择模版`,
                      okText: '确定',
                      maskClosable: true,
                      keyboard: true,
                    })
                    return
                  }
                  saveMedicalRecords('', '')
                }}
              >
                保存
              </Button>
            </Space>
          </Row>
        </Col>
        <Modal
          className={styles.history}
          width={1200}
          style={{ height: 720, maxHeight: 720, overflow: 'hidden' }}
          title='历史就诊信息'
          visible={isModalVisible}
          footer={null}
          onCancel={() => setIsModalVisible(false)}
          destroyOnClose
        >
          <HistoricalRecords
            version={'2'}
            patientId={patientData?.registration?.patientId}
            historicalRecordsBtn={historicalRecordsBtn}
            onCopy={(oldId, beautyId, name) => {
              setHistoricalRecordsBtn(false)

              dispatch(
                getMedicalDetailAsync({
                  id: oldId,
                })
              )
                .then(unwrapResult)
                .then((res: string) => {
                  setSelectTemplate(String(beautyId))
                  setSelectTemplateName(name)
                  setSelectHistoryId('')
                  EditorRendering(refWriterControl.current, res, false)
                  saveMedicalRecords(String(beautyId), name)
                  setIsModalVisible(false)
                }).finally(() => setHistoricalRecordsBtn(true))

            }}
          />
        </Modal>
        <Col
          style={{
            width: 240,
            height: '100%',
            overflow: 'auto',
            marginLeft: readMode ? 10 : 10,
            backgroundColor: theme.pn,
            borderRadius: readMode ? `0 0 ${theme.br}px 0` : `${theme.br}px`,
          }}
        >
          <Label label='诊断记录' style={{ marginLeft: 20 }} />
          <Divider style={{ margin: '0px' }} />
          {data.map((v: any) => (
            <>
              <Row
                key={v.id}
                align='middle'
                justify='space-between'
                wrap={false}
                style={{
                  marginTop: 20,
                  marginLeft: 20,
                  marginRight: 20,
                  flex: 1,
                  overflow: 'auto',
                  backgroundColor: 'transparent',
                  fontWeight: 'normal',
                }}
              >
                {/* <Col span={24}> */}
                <a
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    marginRight: 10,
                    width: '145px',
                    color: '#000',
                  }}
                  title={v.name}
                >
                  {v.name}
                </a>
                <Space className={styles.opBar}>
                  <Button
                    ghost
                    type='link'
                    style={{
                      color: '#027AFF',
                      marginRight: '-5px',
                    }}
                    onClick={() => {
                      if (v.category == 3) {
                        setImgSrc('')
                        v.coherentVideo.split(',').map((v: any) => {
                          dispatch(getUrl({ fileName: v.split('@')[2] })) //获取图片路径
                            .then(unwrapResult)
                            .then((v: any) => {
                              const proxy =
                                window.location.origin.indexOf(
                                  'his.develop.hydhis.com'
                                ) >= 0
                                  ? '/proxyToOssDevPrivate'
                                  : window.location.origin.indexOf(
                                    'his.test.hydhis.com'
                                  ) >= 0
                                    ? '/proxyToOssTestPrivate'
                                    : window.location.origin.indexOf(
                                      'hydhis.cn'
                                    ) >= 0
                                      ? '/proxyToOssProdPrivate'
                                      : '/proxyToOssProdPrivate'
                              const url = (window.location.origin?.includes('localhost')
                                ? 'http://his.develop.hydhis.com'
                                : window.location.origin) + proxy + v
                              setImgSrc(url)
                              setVisible(true)
                            })
                        })
                      } else if (v.category == 1) {
                        dispatch(
                          getMedicalDetailAsync({
                            id: v.id,
                          })
                        )
                          .then(unwrapResult)
                          .then((res: string) => {
                            setSelectTemplate(v.medicalBeautyId)
                            setSelectTemplateName(v.name)
                            setSelectHistoryId(v.id)
                            EditorRendering(refWriterControl.current, res, false)
                            writeBack()
                          })
                      }
                    }}
                    icon={<FemaleFilledIcon style={{ width: '18px', height: '18px' }} />}
                  >
                  </Button>
                  <Button
                    ghost
                    type='link'
                    style={{
                      color: '#FF5D5D',
                    }}
                    onClick={() => {
                      Modal.confirm({
                        title: '是否确认删除?',
                        okText: '确认',
                        cancelText: '取消',
                        onOk: () => {
                          dispatch(getMedicalRemoveAsync({ ids: v.id }))
                            .then(unwrapResult)
                            .then(() => {
                              getMedical()
                              notification.success({
                                message: '删除成功',
                              })
                            })
                        },
                      })
                    }}
                    icon={<DelectOutlined style={{ fill: "#FF5D5D", width: '19px', height: '19px' }} />}
                  >
                  </Button>
                </Space>
              </Row>
              <Row
                key={v}
                align='middle'
                justify='space-between'
                wrap={false}
                style={{
                  marginLeft: 20,
                  marginRight: 20,
                  flex: 1,
                  overflow: 'auto',
                  backgroundColor: 'transparent',
                  fontWeight: 'normal',
                }}
              >
                {/* <Col span={24}> */}
                <span
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    marginRight: 10,
                  }}
                >
                  {v.createTime}
                </span>
              </Row>
            </>
          ))}
        </Col>
        <PrintTemplateModal
          templateCategory={PrintTemplateCategory.Zds}
          visible={isPrintModalVisible && !!treatment?.id}
          treatmentId={treatment?.id}
          onCancel={() => setIsPrintModalVisible(false)}
        />
        <SaveTemplateModal
          categoryName=''
          detail={targetTemplate}
          visible={!!targetTemplate}
          onCancel={() => setTargetTemplate(undefined)}
          onSave={() => setTargetTemplate(undefined)}
        />
      </Row>
      <PrintFrame ref={printRef} direction={'portrait'}>
        {/* <h3>hello</h3> */}
        {printStr && <div dangerouslySetInnerHTML={{ __html: printStr }}></div>}
        {/* {EditorRef.current?.getSdeContent()} */}
      </PrintFrame>
      {/* 上传附件预览 */}
      <Image
        style={{ display: 'none' }}
        src={imgSrc}
        preview={{
          visible,

          onVisibleChange: (value) => {
            setVisible(value)
          },
        }}
      />

      <PreferencesSetModal
        tabNum={'4'}
        isModalVisible={preferencesSetShow}
        handleCancel={() => setiPreferencesSetShow(false)}
        onsubmit={() => {
          PreferencesSetChange && PreferencesSetChange()
          setiPreferencesSetShow(false)
        }}
      />
      <UploadSignatureModal
        uploadModalVisible={isUploadSignatureModalVisible}
        maxCount={1}
        onCancel={() => setIsUploadSignatureModalVisible(false)}
        onSubmit={((options?:any) => {
          const rootElement = refWriterControl.current
            const ops = {
                Width: 250,
                Height: 90,
                SaveContentInFile: true,
                Src: options,
                AutoFitImageSize: true
            };
            rootElement.DCExecuteCommand("InsertImage", false, ops);
            setIsUploadSignatureModalVisible(false)
        })}
      />

    </div>
  )
}

export const BeautyClinicDC = forwardRef(RealBeautyClinicDC)
